import { h } from 'preact'
import { useContext } from 'preact/hooks'
import Default from './Default'
import ManageSettings from './ManageSettings'
import PartnerSettings from './PartnerSettings'
import Overlay from '../blocks/Overlay'
import { Context } from '../context/Context'
import { Views } from '../../enums'

const Modal = () => {
  const globalState = useContext(Context)
  const { state } = globalState
  return state.view && !state.loading ? (
    <Overlay>
      { state.view === Views.default 
        ? <Default />
        : null }
      { state.view === Views.manageSettings
        ? <ManageSettings />
        : null }
      { state.view === Views.partnerSettings
        ? <PartnerSettings />
        : null
      }
    </Overlay>
  ) : null
}

export default Modal
